// extracted by mini-css-extract-plugin
export default {"page-list-input":"styles-module_page-list-input__Wo8E5y","add-listinput-item-button":"styles-module_add-listinput-item-button__LQBtsX","pageText":"styles-module_pageText__QCzUsN"};